<div class="header-wrapper">
  <div class="header-start">
    <fa-icon
      *ngIf="!isMobileScreen"
      [icon]="faBars"
      class="header-icon"
      (click)="onCloseClicked($event)"
      data-cy="nav-toggle"
    ></fa-icon>

    <p-breadcrumb *ngIf="shouldShowBreadcrumbs" [model]="(breadcrumbs$ | async) || []">
      <ng-template pTemplate="item" let-item>
        <ng-container>
          <div
            (click)="item.command && item.command()"
            class="breadcrumb-item"
            [class.breadcrumb-item-current]="!item.command"
          >
            <ng-container *ngIf="item.icon">
              <fa-icon *ngIf="faIcon(item.icon); let icon; else: cssIcon" [icon]="icon"></fa-icon>
              <ng-template #cssIcon><i [ngClass]="item.icon" class="breadcrumb-item-icon"></i></ng-template>
            </ng-container>
            <span>{{ item.label }}</span>
          </div>
        </ng-container>
      </ng-template>
    </p-breadcrumb>
  </div>
  <div class="header-end">
    <span
      *ngIf="impersonatedMerchantName && isMerchantNameVisible"
      class="impersonated-merchant"
      data-cy="impersonated-merchant-name"
    >
      {{ impersonatedMerchantName }}
    </span>

    <button
      #btn
      type="button"
      pButton
      icon="pi pi-angle-down"
      [style]="{ color: 'var(--header-text-color, #fff)' }"
      [label]="fullUserName"
      (click)="menu.toggle($event)"
      data-cy="merchant-header-dropdown"
    ></button>
    <p-tieredMenu
      #menu
      [model]="items"
      [popup]="true"
      [style]="{ background: 'var(--sidebar-bg-primary, #f8f9fa)' }"
    ></p-tieredMenu>
  </div>
</div>
